/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Admin Box
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       24th July 2021

*******************************************************************************************/

import React                    from 'react';
import { styled, Box }          from '@mui/material';
import {
    ItemPaper,
    AdminOnlyTag
}                               from 'components'
import { withTranslation }      from './hoc';
import { useUser }              from 'contexts';

const Container = styled(Box)(({theme}) => ({
    position        : 'absolute',
    transform       : 'translatey(-50%)',
    left            : 0,
    top             : 0,
    marginRight     : theme.spacing(1),
    marginLeft      : theme.spacing(1),
    padding         : 1,
    paddingLeft     : theme.spacing(0.5),
    paddingRight    : theme.spacing(0.5),
    borderRadius    : theme.spacing(0.5),
    fontSize        : 12,
}));

const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'withBorder',
})(({ theme, withBorder = true}) => ({
    position    : 'relative',
    ...(withBorder && {
        padding       : theme.spacing(2),
        paddingTop    : theme.spacing(3),
        border        : '1px dashed red',
        borderRadius  : theme.spacing(2),
    }),
}));

const obj = {};

export const AdminBox = withTranslation( ({t, children, withBorder = true, disabled=false, label=undefined, containerProps = obj, ...props}) => {
    
    const {isAuthenticated,isAdmin} = useUser();
    
    if(!isAuthenticated || !isAdmin)
        return null;

    return (
        <StyledBox component={ItemPaper} {...props} withBorder={withBorder} sx={{p:2,...props?.sx}}>
            <Container {...containerProps}>
                <AdminOnlyTag label={label} />
            </Container>
            {children}
        </StyledBox>
    )
});

export default AdminBox;